// store/studies/persistConfig.ts
import storage from 'redux-persist/lib/storage';

export const studiesPersistConfig = {
  key: 'studies',
  storage,
  whitelist: ['studyId', 'studyName', 'studyProfile', 'yearSelected'],
};
